import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import gameScreenshot from "../../../../src/images/code-master-win.jpg";
import React from 'react';
export default {
  FontAwesomeIcon,
  faCamera,
  gameScreenshot,
  React
};